import { BrandCaptionLowerThirdEntity, RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandCaptionLowerThirdDeleteVO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandCaptionLowerThirdDeleteVO.validationSchema(),
    BrandCaptionLowerThirdEntity
  );

  constructor(readonly value: RoomBrandCaptionLowerThirdDelete) {
    JsonSchemaValidator.assert(
      RoomBrandCaptionLowerThirdDeleteVO.validation,
      value
    );
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "brandCaptionLowerThird"],
      properties: {
        roomId,
        brandCaptionLowerThird: {
          instanceof: BrandCaptionLowerThirdEntity.name
        }
      },
      additionalProperties: false
    };
  }
}

interface RoomBrandCaptionLowerThirdDelete {
  roomId: RoomId;
  brandCaptionLowerThird: BrandCaptionLowerThirdEntity;
}
